import axios from "axios";

export default {
    state: () => ({
        portList : null,
        port : null,
        portImage : null,
        portImageList : null
    }),
    mutations: {
        setPortList:function (state,portList){
            state.portList = portList;
        },
        setPort:function (state,port){
            state.port = port
        },
        setPortImageList:function (state,portImageList){
            state.portImageList = portImageList;
        },
        setPortImage:function (state,portImage){
            state.portImage = portImage
        },
    },
    getters: {
        getPortList : state => {
            return state.portList
        },
        getPort : state => {
            return state.port
        },
        getPortImageList : state => {
            return state.portImageList
        },
        getPortImage : state => {
            return state.portImage
        },
    },
    actions:{
        loadPortList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/port", {headers})
                .then((response) => {
                    context.commit("setPortList", response.data);
                    return response.data;
                })
        },
        loadPort(context, id){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/port/"+id, {headers})
                .then((response) => {
                    context.commit("setPort", response.data);
                    return response.data;
                })
        },
        deletePort(context, port){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/port/"+port.id, {headers})
                .then((response) => {
                    let portList = context.getters.getPortList
                    portList.splice(portList.indexOf(port), 1)
                    context.commit("setPortList",portList);
                    return response.data;
                })
        },
        createPort(context, port){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/port", port,{headers})
                .then((response) => {
                    context.commit("setPort",response.data)
                    return response.data;
                })

        },
        updatePort(context, port){
            let imageUrl = port.imageUrl;

            if(port.imageUrl.startsWith("http")){
                port.imageUrl = null;
            }

            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/port", port,{headers})
                .then((response) => {
                    if(imageUrl.startsWith("http")){
                        port.imageUrl = imageUrl;
                    }else{
                        port.imageUrl = response.data.imageUrl;
                    }
                    return response.data;
                })
        },
        createPortImage(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/port/images", request,{headers})
                .then((response) => {
                    let portImageList = context.getters.getPortImageList;
                    portImageList.push(response.data);

                    context.commit("setPortImage",response.data)
                    context.commit("setPortImageList", portImageList);

                    return response.data;
                })
        },
        deletePortImage(context, imageId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/port/images/"+imageId,{headers})
                .then((response) => {
                    let portImageList = context.getters.getPortImageList;
                    portImageList = portImageList.filter(portImage=>{
                        return portImage.id !== imageId;
                    });
                    context.commit("setPortImageList", portImageList);

                    return response.data;
                })
        },
        loadPortImages(context,portId){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/port/"+portId+"/images",{headers})
                .then((response) => {
                    this.commit("setPortImageList",response.data)
                    return response.data;
                })
        },
    }
}

